import authenticationManager from '@/services/auth/manager';
import { drawerOpenAtom } from '@/store/ui/drawer';
import { useLocation } from '@tanstack/react-router';
import { useSetAtom } from 'jotai';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useHeader = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const setIsSideMenuOpen = useSetAtom(drawerOpenAtom);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isSignOutInProgress, setIsSignOutInProgress] = useState(false);

  const title = useMemo(() => {
    const firstSegment = location.pathname.split('/')[1];
    return t(`${firstSegment}.title`);
  }, [t, location.pathname]);

  const handleClickAccount = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAccount = () => {
    setAnchorEl(null);
  };

  const handleClickLogout = async () => {
    setIsSignOutInProgress(true);
    try {
      await authenticationManager.userManager.signOutRedirect();
    } catch (error) {
      console.error('Sign out redirect error: ', error);
      setIsSignOutInProgress(false);
    } finally {
      setIsSignOutInProgress(false);
    }
  };

  const handleClickMenu = useCallback(() => {
    setIsSideMenuOpen(true);
  }, [setIsSideMenuOpen]);

  return {
    title,
    anchorEl,
    isSignOutInProgress,
    handleClickAccount,
    handleCloseAccount,
    handleClickLogout,
    handleClickMenu,
  };
};
